import React from "react";
import {useHistory} from "react-router-dom";
import styled from "styled-components";

const NotFound =(props) =>{
    const history =useHistory();

    return(
        <>
        <NotOutter>
            <h1>주소가 올바르지 않아요!!</h1>
            <button onClick={()=>{
                history.goBack();
            }}>뒤로가기</button>
        </NotOutter>
        </>
    )
};
const NotOutter=styled.div`
    width:100%;
    position:relative;
    top:80px;
    height:100%;
    padding:60px;
    display:flex;
    align-items:center;
    flex-direction:column;
    gap:30px;
    @media screen and (max-width: 500px){
        top:60px;
        }
    
    & > h1 {
        text-align:center;
        font-family:"Gugi";
        width:40%;
        background: #fff;
        opacity:0.8;
        @media screen and (max-width: 500px){
        font-size: 24px;
        }
    }
    & > button {
        width:150px;
        height: 40px;
        font-family:"Gugi";
        font-size: 21px;
        cursor:pointer;
        background:#97ACE3;
        color:#123389;
        border-radius:8px;
    }
    & > button:hover{
            background:#123389;
            color:#97ACE3;
        }
`

export default NotFound;